import throttle from './throttle'

const install = function(Vue) {
  Vue.directive('throttle', throttle)
}

if (window.Vue) {
  window.waves = throttle
  Vue.use(install); // eslint-disable-line
}

throttle.install = install
export default throttle



// WEBPACK FOOTER //
// ./src/utils/clickAgain.js